export const messages = {
    "wr-dashboard.search.input.hint": "Hledat",
    "wr-dashboard.search.label.breadcrumb": "Výsledky hledání",
    "wr-dashboard.search.message.empty": "Hledání neodpovídají žádné položky.",
    "wr-dashboard.side-bar.selected.title:plural": "Počet vybraných položek: {count} | {count} položka vybrána | Počet vybraných položek: {count} | Počet vybraných položek: {count} | Počet vybraných položek: {count}",
    "wr-dashboard.side-bar.backup-type.disk": "Disk",
    "wr-dashboard.side-bar.backup-type.file": "Soubor",
    "wr-dashboard.side-bar.backup-type.notarized": "Notarizované soubory a složky",
    "wr-dashboard.side-bar.backup-type.exchange": "Aplikace – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Aplikace – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Aplikace – stav systému",
    "wr-dashboard.side-bar.backup-type.application": "Aplikace",
    "wr-dashboard.backups-table.column.name": "Název",
    "wr-dashboard.backups-table.column.size": "Velikost",
    "wr-dashboard.backups-table.column.version": "Poslední verze",
    "wr-dashboard.backups-table.action.delete": "Odstranit",
    "wr-dashboard.backups-table.message.no-backups": "V cloudu zatím nejsou žádné zálohy.",
    "wr-dashboard.backups-sidebar.label.size": "Velikost",
    "wr-dashboard.backups-sidebar.label.type": "Typ",
    "wr-dashboard.backups-sidebar.label.version": "Poslední verze",
    "wr-dashboard.backups-sidebar.label.created": "Vytvořeno",
    "wr-dashboard.backups-sidebar.label.machine": "Počítač",
    "wr-dashboard.backups-sidebar.label.owner": "Vlastník",
    "wr-dashboard.content-table.column.name": "Název",
    "wr-dashboard.content-table.column.versions": "Verze",
    "wr-dashboard.content-table.column.volumes": "Svazky",
    "wr-dashboard.content-table.column.path": "Cesta",
    "wr-dashboard.content-table.column.size": "Velikost",
    "wr-dashboard.content-table.column.version": "Poslední verze",
    "wr-dashboard.content-table.action.notary-verify": "Ověřit",
    "wr-dashboard.content-table.action.notary-get-crt": "Získat certifikát",
    "wr-dashboard.content-table.action.asign": "Odeslat k podpisu",
    "wr-dashboard.content-table.action.versions": "Verze",
    "wr-dashboard.content-table.action.restore": "Stáhnout",
    "wr-dashboard.content-table.label.size": "Velikost",
    "wr-dashboard.content-table.label.created": "Vytvořeno",
    "wr-dashboard.content-table.label.modified": "Změněno",
    "wr-dashboard.content-table.message.empty-folder": "Tato složka je prázdná.",
    "wr-dashboard.password-dialog-box.title.backup": "Zašifrovaná záloha",
    "wr-dashboard.password-dialog-box.title.archive": "Šifrovaný archiv",
    "wr-dashboard.password-dialog-box.message.backup": "Zadejte heslo pro přístup k záloze {displayName}.",
    "wr-dashboard.password-dialog-box.message.archive": "Zadejte heslo pro přístup k archivu {displayName}.",
    "wr-dashboard.password-dialog-box.hint.password": "Heslo",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Heslo je nesprávné",
    "wr-dashboard.form.button.open": "Otevřít",
    "wr-dashboard.form.button.close": "Zavřít",
    "wr-dashboard.form.button.cancel": "Storno",
    "wr-dashboard.form.button.continue": "Pokračovat",
    "wr-dashboard.form.button.proceed": "Pokračovat",
    "wr-dashboard.form.button.delete": "Odstranit",
    "wr-dashboard.form.button.done": "Hotovo",
    "wr-dashboard.form.button.retry": "Opakovat",
    "wr-dashboard.notary.verify.view.status.downloading": "Stahování...",
    "wr-dashboard.notary.verify.view.status.validating": "Ověřování...",
    "wr-dashboard.notary.verify.view.status.pending": "Čeká se na certifikát...",
    "wr-dashboard.notary.verify.view.status.fail": "Neshodný certifikát...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Získat certifikát",
    "wr-dashboard.notary.verify.view.file-info.name": "JMÉNO",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "PODPIS",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATUM ZÁLOHY",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATUM NOTARIZACE",
    "wr-dashboard.notary.verify.view.button.cancel": "Storno",
    "wr-dashboard.notary.verify.view.button.done": "Hotovo",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Nepodporovaná verze prohlížeče",
    "wr-dashboard.versions-dialog-box.title": "Verze {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Odeslat k podpisu",
    "wr-dashboard.asign-dialog-box.message": "Verze souboru je sdílena, ale soubor si nikdo nemůže zobrazit bez odkazu. Přejděte do ASign, přidejte signatáře a sdílejte odkaz.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Zobrazit podrobnosti souboru",
    "wr-dashboard.page-not-found.title": "Stránka nebyla nalezena.",
    "wr-dashboard.page-not-found.message.main": "Hledaná stránka nebyla nalezena.",
    "wr-dashboard.page-not-found.message.description": "Odkaz může být zastaralý nebo jste možná zadali nesprávnou adresu.",
    "wr-dashboard.page-not-found.message.error": "Chybový kód: 404",
    "wr-dashboard.server-error.title": "Server je nedostupný.",
    "wr-dashboard.server-error.message": "Server momentálně není k dispozici. Zkuste to znovu později.",
    "wr-dashboard.server-error.message.error": "Chybový kód: 500",
    "wr-dashboard.account-menu.action.sign-out": "Odhlásit",
    "wr-dashboard.breadcrumb.item.machines": "Počítače",
    "wr-dashboard.breadcrumb.item.failed-backups": "Neúspěšné zálohy",
    "wr-dashboard.machines-table.column.name": "Název",
    "wr-dashboard.machines-table.column.size": "Velikost",
    "wr-dashboard.machines-table.message.no-machines": "V cloudu zatím nejsou žádné počítače.",
    "wr-dashboard.incomplete-backups.message.status:plural": "Máte neúspěšné nebo neúplné zálohy ({count}), které zabírají {size} úložiště. | Máte {count} neúspěšnou nebo neúplnou zálohu, která zabírá {size} úložiště. | Máte neúspěšné nebo neúplné zálohy ({count}), které zabírají {size} úložiště. | Máte neúspěšné nebo neúplné zálohy ({count}), které zabírají {size} úložiště. | Máte neúspěšné nebo neúplné zálohy ({count}), které zabírají {size} úložiště.",
    "wr-dashboard.incomplete-backups.button.view": "Zobrazit zálohy",
    "wr-dashboard.incomplete-backups.button.delete": "Odstranit zálohy",
    "wr-dashboard.machines-table.message.space-used:plural": "Celkové využití záloh: {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Odstranit archivy",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Odstranit neúplné archivy",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Odstranit všechny neúplné archivy",
    "wr-dashboard.delete-archive.message": "Opravdu chcete vybrané archivy trvale odstranit ze všech umístění? Veškerá data budou vymazána a nebude možné je obnovit.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Změny provedené v této konzoli Web Restore se nemusí vizuálně projevit v příslušném pracovním zatížení konzole ochrany, pokud dané pracovní zatížení není online nebo pokud není online agent, který by změny zpracoval.",
    "wr-dashboard.delete-archive.locked-error-message": "Archiv byla uzamčen, aby byla zajištěna konzistence dat. Ukončete všechny operace s tímto archivem (např. procházení, obnovení, zálohování) a zkuste to znovu.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Certifikát čeká na vyřízení.",
    "wr-dashboard.certificate-pending-dialog-box.message": "Zkuste to znovu za chvíli.",
    "wr-dashboard.form.button.ok": "OK"
};
